module.exports = __webpack_public_path__ + "img/excel.200d3cfe.svg";